/*
 * @Description: computer actions type
 */

export enum ComputerActionTypes {
  //导航
  ACTION_SET_NAV_CONFIG = 'ACTION_SET_NAV_CONFIG', //获取PC导航配置
  ACTION_ADD_NAV_LIST = 'ACTION_ADD_NAV_LIST', //增加导航
  ACTION_DEL_NAV_LIST = 'ACTION_DEL_NAV_LIST', //删除导航
  ACTION_MODIFY_NAV_LIST = 'ACTION_MODIFY_NAV_LIST', //编辑导航链接
  // 页脚
  ACTION_SET_FOOTER_CONFIG = 'ACTION_SET_FOOTER_CONFIG', //获取PC页脚配置
  // 微门户页面配置
  ACTION_PC_MODIFY_PAGE_CONFIG = 'ACTION_PC_MODIFY_PAGE_CONFIG', //页面配置
  //预览保存
  ACTION_SUBMIT_AND_PREVIEW_PAGE = 'ACTION_SUBMIT_AND_PREVIEW_PAGE'
}
